import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const ScreenEthnicityStyles = styled(OnboardingPage)`
  .local-title {
    margin: 20px auto 40px;
  }
`;
